import React, { useEffect, useState } from 'react';
import {
  Alert, Box, Paper, Snackbar, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Typography,
} from '@mui/material';
import AdminService from '../../services/AdminService';

export default function CredentialsView() {
  const [credentials, setCredentials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'error' });

  useEffect(() => {
    AdminService.getAllCredentials()
      .then((data) => setCredentials(data || []))
      .catch(() => setSnackbar({ open: true, message: 'Failed to load credentials', severity: 'error' }))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" fontWeight={600} mb={2}>WhatsApp Credentials</Typography>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Service ID</TableCell>
              <TableCell>Phone Number</TableCell>
              <TableCell>Phone Number ID</TableCell>
              <TableCell>WABA ID</TableCell>
              <TableCell>Expires In</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow><TableCell colSpan={5} align="center">Loading…</TableCell></TableRow>
            ) : credentials.length === 0 ? (
              <TableRow><TableCell colSpan={5} align="center">No credentials found</TableCell></TableRow>
            ) : credentials.map((c) => (
              <TableRow key={c.id} hover>
                <TableCell sx={{ fontFamily: 'monospace', fontSize: 12 }}>{c.service_id}</TableCell>
                <TableCell>{c.phone_number || '—'}</TableCell>
                <TableCell sx={{ fontFamily: 'monospace', fontSize: 12 }}>{c.phone_number_id || '—'}</TableCell>
                <TableCell sx={{ fontFamily: 'monospace', fontSize: 12 }}>{c.waba_id || '—'}</TableCell>
                <TableCell>{c.expires_in || '—'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
        <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
}
